module.exports = __webpack_public_path__ + "static/media/moss.9646d3be.png";